import { render } from "./vdercontractlist.vue?vue&type=template&id=37b2002e&scoped=true"
import script from "./vdercontractlist.vue?vue&type=script&lang=js"
export * from "./vdercontractlist.vue?vue&type=script&lang=js"

import "./vdercontractlist.vue?vue&type=style&index=0&id=37b2002e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b2002e"]])

export default __exports__